export default {"src":"/uk/_next/static/media/accountIconGrey.a82c1928.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};